import { render, staticRenderFns } from "./CommunicationFilePreview.vue?vue&type=template&id=7f725094&scoped=true"
import script from "./CommunicationFilePreview.vue?vue&type=script&lang=ts"
export * from "./CommunicationFilePreview.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationFilePreview.vue?vue&type=style&index=0&id=7f725094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f725094",
  null
  
)

export default component.exports